<template>
  <div>
    <q-dialog :visible.sync="dialogVisible" title="准备上架失败" :innerHeight="360" width="900px" :showFooter="false" @close="updateVal">
      <el-table
        ref="table"
        v-loading="loading"
        element-loading-text="数据加载中"
        element-loading-spinner="el-icon-loading"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        :data="tableData"
        :height="360"
        class="full-width-table"
        border
      >
        <el-table-column label="SKU编码" prop="skuCode" show-overflow-tooltip width="150"></el-table-column>
        <el-table-column label="SKU名称" prop="name" show-overflow-tooltip min-width="130"></el-table-column>
        <el-table-column label="更新时间" prop="creationDate" show-overflow-tooltip width="160"></el-table-column>
        <el-table-column label="更新原因" prop="errMsg" show-overflow-tooltip min-width="160"></el-table-column>
      </el-table>
    </q-dialog>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'visible',
    event: 'input',
  },
  props: ['visible','skuId','spuId'],
  data() {
    return {
      dialogVisible: false,
      loading: false,
      tableData: []
    };
  },
  mounted() {
    this.dialogVisible = this.visible;
    this.init()
  },
  methods: {
    init() {
      this.loading = true;
      let data = {
        skuId: +this.skuId,
        spuId: this.spuId
      }
      this.searchFormData = data;
      this.$q.newProduct
        .prepareErrorPageList({ data: data })
        .then((res) => {
          this.tableData = res.data
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateVal() {
      this.dialogVisible = false;
      setTimeout((_) => {
        this.$emit('input', false);
      }, 200);
    },
  },
};
</script>

<style></style>
